import { render, staticRenderFns } from "./Depend.vue?vue&type=template&id=50be4d69&"
import script from "./Depend.vue?vue&type=script&lang=js&"
export * from "./Depend.vue?vue&type=script&lang=js&"
import style0 from "./Depend.vue?vue&type=style&index=0&id=50be4d69&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports